import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../components/Navbar";
import Styles from "../../styles/session/assignformatsecond.module.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import { useDispatch, useSelector } from "react-redux";

import {
  getCategory,
  getExercisesByCategory,
  getFormatSessionById,
} from "../../services";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Swal from "sweetalert2";
import Close_Button from "../../assets/auth/close.png";
import Nomore from "../../assets/session/no-more.png";
import { toggle, updateSessionData } from "../../redux";
import Dndfirstimg from "../../assets/session/dndfirst.png";
import Dndsecondimg from "../../assets/session/dndsecond.png";
import { FaSearch } from "react-icons/fa";

const EditAssignFormatSecond = () => {
  const { sessionDetails, formats, sessionFormat, sessionData } = useSelector(
    (state) => state.sessionFormats
  );

  const { categories } = useSelector((state) => state.exercises);
  const [exercises, setExercises] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [droppedItems, setDroppedItems] = useState([]);
  const [filteredExercises, setFilteredExercises] = useState([]);
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const navigate = useNavigate();
  const typeRef = useRef();
  const dispatch = useDispatch();
  const { formatId } = useParams();
   const [searchQuery, setSearchQuery] = useState("");
    const [page, setPage] = useState(1);
    const LIMIT = 10; // or whatever value you need
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [sortOrder, setSortOrder] = useState("latest");
    const categoryId = selectedCategory?._id;
  
  const ItemTypes = {
    EXERCISE: 'EXERCISE',
    DROPPED_ITEM: 'DROPPED_ITEM'
  };
  useEffect(() => {
    if (sessionData && Object.keys(sessionData).length > 0) {
      // Prioritize saved sessionData if it exists
      if (sessionData.categoryId) {
        const selected = categories.find((cat) => cat._id === sessionData.categoryId);
        if (selected) {
          setSelectedCategory(selected);
          // When restoring from saved state, fetch exercises and preserve the type
          handleCategoryChange({ target: { value: selected._id } }, sessionData.type);
        }
      }
      setSelectedType(sessionData.type || null);
      setDroppedItems(sessionData.droppedExercises || []);
    } else if (sessionFormat?.exercises?.length > 0) {
      // Fallback to API data if no saved sessionData
      const exercise = sessionFormat.exercises[0];
      const { category, type } = exercise;

      setSelectedCategory(category);
      setSelectedType(type);
      if (category?._id) {
        handleCategoryChange({ target: { value: category._id } }, type);
      }
      setDroppedItems(sessionFormat.exercises.map((ex) => ({ ...ex })));
    }
  }, [sessionFormat, sessionData, categories]);

  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };
  const handleCategoryChange = async (event, defaultType = null) => {
    const categoryId = event.target.value;
    const selected = categories.find((cat) => cat._id === categoryId);
    setSelectedCategory(selected);

    try {
      const response = await getExercisesByCategory(false, categoryId);
      const exercisesData = Array.isArray(response) ? response : [];

      setExercises(exercisesData);
      setFilteredExercises(exercisesData);

      let matchedType = defaultType || null;
      if (!matchedType && selected?.subCategories?.length > 0) {
        matchedType = selected.subCategories.find((sub) =>
          exercisesData.some((exercise) => exercise.type === sub)
        );
      }

      setSelectedType(matchedType || selected?.subCategories?.[0] || null);

      console.log("Updated category:", selected.name);
      console.log("Available types:", selected?.subCategories);
      console.log("Matched type:", matchedType);
    } catch (error) {
      console.error("Error fetching exercises by category:", error);
    }
  };

  const handleTypeChange = (event) => {
    const type = event.target.value;
    setSelectedType(type);

    if (type) {
      const filtered = exercises.filter((exercise) => exercise.type === type);
      setFilteredExercises(filtered.length > 0 ? filtered : exercises);
    } else {
      setFilteredExercises(exercises);
    }
  };

  useEffect(() => {
    const fetchData = () => {
      getCategory();
      if (formatId) {
        getFormatSessionById(formatId);
      }
    };
    fetchData();
  }, []);

  const moveItem = (dragIndex, hoverIndex) => {
    setDroppedItems((prevItems) => {
      const dragItem = prevItems[dragIndex];
      const newItems = [...prevItems];
      
      // Remove the item at dragIndex
      newItems.splice(dragIndex, 1);
      
      // Insert it at hoverIndex
      newItems.splice(hoverIndex, 0, dragItem);
      
      return newItems;
    });
  };

  const fetchExercisesById = async (page, query = "", sort = sortOrder) => {
    if (loading) return;

    try {
      setLoading(true);
      console.log("Fetching Exercises for page:", page);

      const newExercises = await getExercisesByCategory(
        false,
        categoryId,
        page,
        LIMIT,
        query,
        sort
      );

      if (
        newExercises &&
        Array.isArray(newExercises) &&
        newExercises.length > 0
      ) {
        setExercises((prev) => [...prev, ...newExercises]);
        setPage((prev) => prev + 1);
        console.log("Fetched new Exercises:", newExercises.length);
      } else {
        console.log("No more Exercises to fetch");
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching Exercises:", error);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };
  const handleSearch = async (e, sort = sortOrder) => {
    const query = e.target.value;
    setSearchQuery(query);
  
    try {
      if (query.trim() === "") {
        setExercises([]);
        setFilteredExercises([]); 
        setPage(1);
        setHasMore(true);
        setTimeout(() => {
          fetchExercisesById(1, "", sort);
        }, 1);
      } else {
        const newExercises = await getExercisesByCategory(
          false,
          categoryId,
          1, // Always search from page 1
          LIMIT,
          query,
          sort
        );
        if (Array.isArray(newExercises)) {
          setExercises(newExercises); 
          setFilteredExercises(newExercises); 
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("Search error:", error);
    }
  };
  

  const ExerciseItem = ({ exercise, onRemove, index, moveItem, inDropZone = false }) => {
    const ref = useRef(null);
    
    // Set up drag functionality
    const [{ isDragging }, dragRef] = useDrag(() => ({
      type: inDropZone ? ItemTypes.DROPPED_ITEM : ItemTypes.EXERCISE,
      item: inDropZone 
        ? { id: exercise._id, index, type: ItemTypes.DROPPED_ITEM }
        : { id: exercise._id, name: exercise.name || exercise.exercise?.name, type: ItemTypes.EXERCISE },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }));
    
    // Set up drop functionality for reordering (only for items in drop zone)
    const [, dropRef] = useDrop({
      accept: ItemTypes.DROPPED_ITEM,
      hover(item, monitor) {
        if (!inDropZone || !ref.current) return;
        if (item.type !== ItemTypes.DROPPED_ITEM) return;
        
        const dragIndex = item.index;
        const hoverIndex = index;
        
        // Don't replace items with themselves
        if (dragIndex === hoverIndex) return;
        
        // Determine rectangle on screen
        const hoverBoundingRect = ref.current.getBoundingClientRect();
        
        // Get vertical middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        
        // Determine mouse position
        const clientOffset = monitor.getClientOffset();
        
        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;
        
        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%
        
        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
        
        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;
        
        // Time to actually perform the action
        moveItem(dragIndex, hoverIndex);
        
        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        item.index = hoverIndex;
      },
    });
    
    // Apply both drag and drop refs
    inDropZone ? dragRef(dropRef(ref)) : dragRef(ref);

    return (
      <div
        ref={ref}
        style={{
          opacity: isDragging ? 0.5 : 1,
          backgroundColor: "#333",
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          color: "#fff",
          padding: "15px",
          color: "#F3F3F6",
          fontFamily: "gothambold",
          margin: "2px 0",
          borderRadius: "12px",
          boxShadow: "0 1px 2px rgba(0,0,0,0.5)",
          cursor: "grab",
          border: inDropZone ? "2px solid #5E5E5E" : "2px solid #5E5E5E",
          position: "relative",
          background: "linear-gradient(180deg, #323232 0%, #464646 100%)",
        }}
      >
        {inDropZone && (
          <div style={{ 
            position: "absolute", 
            left: "10px", 
            top: "50%", 
            transform: "translateY(-50%)",
            color: "#F79328"
          }}>
           
          </div>
        )}
        <span style={{ marginLeft: inDropZone ? "25px" : "0" }}>
          {exercise.exercise?.name || exercise.name}
        </span>
        <button
          onClick={() => onRemove(exercise._id)}
          style={{
            background:
              "linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), linear-gradient(0deg, #464646 0%, #323232 100%)",
            border: "1px solid #5E5E5E",
            color: "#E27908",
            fontSize: "16px",
            cursor: "pointer",
            fontWeight: "bold",
            borderRadius: "0px 12px 12px 0px",
            alignItems: "right",
            position: "absolute",
            right: "0",
            top: "0",
            width: "60px",
            height: "48px",
            marginTop: "0px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M15 9L9 14.9996M15 15L9 9.00039"
              stroke="#F79328"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
              stroke="#F79328"
              strokeWidth="1.5"
            />
          </svg>
        </button>
      </div>
    );
  };
  const DroppableContainer = ({ className }) => {
    const [{ isOver }, dropRef] = useDrop(() => ({
      accept: [ItemTypes.EXERCISE, ItemTypes.DROPPED_ITEM],
      drop: (item, monitor) => {
        // Only handle drops from the exercise list, not reordering
        if (item.type === ItemTypes.EXERCISE) {
          handleDrop(item);
        }
      },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
      }),
    }));

    const handleDrop = (item) => {
      const fullExercise = exercises.find(
        (exercise) => exercise._id === item.id
      );
      if (!fullExercise) return;

      const exerciseWithFallback = {
        ...fullExercise,
        name: fullExercise.name || fullExercise.exercise?.name || "",
      };

      setDroppedItems((prev) => {
        const isDuplicate = prev.some(
          (droppedItem) =>
            (droppedItem.exercise?._id || droppedItem._id) ===
            exerciseWithFallback._id
        );

        if (isDuplicate) {
          Swal.fire({
            html: `
              <div style="text-align: center; border-radius: 20px; position: relative; padding: 30px;">
                <button 
                  id="customCloseButton" 
                  style="position: absolute; top:-10px; right:-20px; background: none; border: none; cursor: pointer;">
                  <img 
                    src=${Close_Button} 
                    alt="Close" 
                    style="width: 50px; height: 50px;"
                  />
                </button>
                <img 
                  src=${Nomore} 
                  alt="Warning" 
                  style="width: 100px; margin-bottom: 20px;" 
                />
              <p style="color: #151515; text-align:center; font-family:gothambold; font-size:1.5rem;">
                             This exercise is already added!

                </p>
                <button 
                  id="backButton" 
                  style="background: white; color: #151515;  padding: 15px 20px; font-family:gothambold; border-radius: 8px; cursor: pointer; margin-top: 30px;border: 1px solid #E27808;width:250px;height:48px;font-size:14px;">
                  Back
                </button>
              </div>
            `,
            showConfirmButton: false,
            width: "500px",
            customClass: {
              popup: "custom-swal-container",
            },
            didOpen: () => {
              const backButton = document.getElementById("backButton");
              const closeButton = document.getElementById("customCloseButton");

              backButton.addEventListener("click", () => {
                Swal.close();
              });

              closeButton.addEventListener("click", () => {
                Swal.close();
              });
            },
          });
          return prev; 
        }

        if (prev.length >= 5) {
          Swal.fire({
            html: `
              <div style="text-align: center; border-radius: 20px; position: relative; padding: 30px;">
                <button 
                  id="customCloseButton" 
                  style="position: absolute; top:-10px; right:-20px; background: none; border: none; cursor: pointer;">
                  <img 
                    src=${Close_Button} 
                    alt="Close" 
                    style="width: 50px; height: 50px;"
                  />
                </button>
                <img 
                  src=${Nomore} 
                  alt="Warning" 
                  style="width: 100px; margin-bottom: 20px;" 
                />
              <p style="color: #151515; text-align:center; font-family:gothambold; font-size:1.5rem;">
                  You cannot add more than <span style="color:#FF8C00; font-weight:bold;">5</span> exercises to a format
                </p>
                <button 
                  id="backButton" 
                  style="background: white; color: #151515;  padding: 15px 20px; font-family:gothambold; border-radius: 8px; cursor: pointer; margin-top: 30px;border: 1px solid #E27808;width:250px;height:48px;font-size:14px;">
                  Back
                </button>
              </div>
            `,
            showConfirmButton: false,
            width: "500px",
            customClass: {
              popup: "custom-swal-container",
            },
            didOpen: () => {
              const backButton = document.getElementById("backButton");
              const closeButton = document.getElementById("customCloseButton");

              backButton.addEventListener("click", () => {
                Swal.close();
              });

              closeButton.addEventListener("click", () => {
                Swal.close();
              });
            },
          });
          return prev;
        }

        return [...prev, exerciseWithFallback]; 
      });
    };

    const handleRemove = (id) => {
      setDroppedItems((prev) => prev.filter((item) => item._id !== id));
    };

    return (
      <div
        ref={dropRef}
        className={className}
        style={{
          padding: "1rem 2rem",
          borderRadius: "8px",
          minHeight: "400px",
          width: "100%",
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          border: isOver ? "none" : "none",
        }}
      >
        {droppedItems.length > 0 ? (
          droppedItems.map((item, index) => (
            <ExerciseItem
              key={item._id}
              exercise={item}
              index={index}
              moveItem={moveItem}
              inDropZone={true}
              onRemove={handleRemove}
            />
          ))
        ) : (
          <div className={Styles.draganddropsecondimgmain}>
            <img src={Dndsecondimg} />
          </div>
        )}
      </div>
    );
  };

  const handleSave = () => {
    const sessionData = {
      categoryId: selectedCategory?._id || sessionFormat?.format?._id || null,
      sessionId: formats.sessionId || null,
      formatId: formats.formatId || null,
      type: selectedType || null,
      droppedExercises: droppedItems || sessionFormat.exercises,
    };

    dispatch(updateSessionData(sessionData));
    navigate(adminRoutes.editCreateNewFormatEdit.replace(":formatId", formatId || formats?.formatId));
  };

  const handleBack = async () => {
    const currentData = {
      categoryId: selectedCategory?._id || sessionFormat?.format?._id || null,
      sessionId: formats.sessionId || null,
      formatId: formats.formatId || null,
      type: selectedType || null,
      droppedExercises: droppedItems,
    };
    dispatch(updateSessionData(currentData));
    navigate(adminRoutes.editFormat.replace(":formatId", formatId || formats?.formatId));
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <Navbar />
      <div
        className={Styles.assign_list_container}
        onClick={handleMainContainerClick}
      >
        <h2>
          <Link to={adminRoutes.listSession}>HOME / </Link>
          <span> CREATE NEW FORMAT</span>
        </h2>
        <div className={Styles.table_container_main}>
          <div className={Styles.table_container}>
            <div className={Styles.table_container_heading}>
              <div className={Styles.table_container_headingone}>
                <h6>Format Name</h6>
                <h3>{formats?.format}</h3>
              </div>
              <div className={Styles.table_container_headingtwo}>
                <div className={Styles.create_new_assign}>
                  <h6>Session Name</h6>
                  <p>{formats?.sessionDetails?.name}</p>
                </div>
              </div>
            </div>
            <div className={Styles.seperator}>
              <hr className={Styles.line} />
            </div>
          </div>
          <div className={Styles.progress_indicator}>
            <div className={Styles.progress_line}>
              <div className={`${Styles.step} ${Styles.active}`}>
                <div className={Styles.circle}></div>
              </div>
              <div className={`${Styles.line} ${Styles.active}`}></div>

              <div className={`${Styles.step} ${Styles.active}`}>
                <div className={Styles.circle}></div>
              </div>
              <div className={`${Styles.line} ${Styles.inactive}`}></div>

              <div className={`${Styles.step} ${Styles.inactive}`}>
                <div className={Styles.circle}></div>
              </div>
            </div>
            <div className={Styles.label}>Drag And Drop The Exercises</div>
          </div>

          <div className={Styles.container_main}>
            <div className={Styles.drag_and_drop_containerfirst}>
              <div className={Styles.drag_and_drop_containerfirstone}>
                <label>Exercise</label>
                <select
                  className={Styles.dropdown_select}
                  onChange={handleCategoryChange}
                  value={selectedCategory?._id || ""}
                >
                  {" "}
                  <option value="">Choose from list</option>
                  {categories.map((category) => (
                    <option key={category._id} value={category._id}>
                      {category.name}
                    </option>
                  ))}
                </select>
                {selectedCategory &&
                  selectedCategory.subCategories.length > 0 && (
                    <div className={Styles.radio_container}>
                      <span>Types</span>
                      {selectedCategory.subCategories.map(
                        (subCategory, index) => (
                          <label key={index}>
                            <input
                              type="radio"
                              name="subCategories"
                              value={subCategory}
                              onChange={handleTypeChange}
                              checked={selectedType === subCategory}
                            />
                            {subCategory || "N/A"}
                          </label>
                        )
                      )}
                        <div className={Styles.rightControls}>
                        <div
                          className={`${Styles.searchContainerchildtwo} ${
                            searchQuery ? Styles.active : ""
                          }`}
                        >
                          <FaSearch className={Styles.searchIcon} />
                          <input
                            type="text"
                            className={Styles.searchInput}
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                <div className={Styles.drag_and_drop_containerfirsttwo}>
                  {filteredExercises.length > 0 ? (
                    filteredExercises.map((exercise) => (
                      <div>
                        <ExerciseItem
                          key={exercise._id}
                          exercise={exercise}
                          className={Styles.exercise_item}
                        />
                      </div>
                    ))
                  ) : exercises.length > 0 ? (
                    exercises.map((exercise) => (
                      <div>
                        <ExerciseItem
                          key={exercise._id}
                          exercise={exercise}
                          className={Styles.exercise_item}
                        />
                      </div>
                    ))
                  ) : (
                    <div className={Styles.draganddropfirstimgmain}>
                      <img src={Dndfirstimg} />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={Styles.drag_and_drop_containersecond}>
              <DroppableContainer
                className={Styles.droppable_container}
                exercises={filteredExercises}
              />
            </div>
          </div>
          <div className={Styles.seperator}>
            <hr className={Styles.line} />
          </div>
          <div className={Styles.button_group}>
            <button
              className={`${Styles.button} ${Styles.save_button}`}
              onClick={handleSave}
            >
              Next
            </button>
            <button
              className={`${Styles.button} ${Styles.cancel_button}`}
              onClick={handleBack}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </DndProvider>
  );
};

export default EditAssignFormatSecond;
